var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_1640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7781 0.480469H5.22255V1.66565H8.7781V0.480469ZM11.1663 4.26714L12.0077 3.42565C11.7529 3.12343 11.4744 2.83899 11.1722 2.5901L10.3307 3.43158C9.41218 2.69677 8.25662 2.25825 7.00033 2.25825C4.05514 2.25825 1.66699 4.64639 1.66699 7.59158C1.66699 10.5368 4.04921 12.9249 7.00033 12.9249C9.95144 12.9249 12.3337 10.5368 12.3337 7.59158C12.3337 6.33528 11.8951 5.17973 11.1663 4.26714ZM7.00033 11.7397C4.70699 11.7397 2.85218 9.88491 2.85218 7.59158C2.85218 5.29825 4.70699 3.44343 7.00033 3.44343C9.29366 3.44343 11.1485 5.29825 11.1485 7.59158C11.1485 9.88491 9.29366 11.7397 7.00033 11.7397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70224 10.7028H6.33187L6.70224 8.11021H5.40595C5.19113 8.11021 5.19484 7.99169 5.26521 7.86576C5.33558 7.73984 5.28373 7.83613 5.29113 7.82132C5.76891 6.97687 6.48743 5.71761 7.44299 4.03613H7.81336L7.44299 6.62873H8.73928C8.92076 6.62873 8.94669 6.75095 8.91336 6.81761L8.88743 6.87317C7.42817 9.42502 6.70224 10.7028 6.70224 10.7028Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_1640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(0.600098 0.599609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/TimerIcon.77d81187dd805ab6978fd57fc6bab32f.svg";
export { ForwardRef as ReactComponent };